import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';

@Component({
  selector: 'app-product-add',
  templateUrl: './product-add.component.html',
  styleUrls: ['./product-add.component.scss']
})
export class ProductAddComponent implements OnInit {

  public dropdownSettings = {};
  public dropdownList = [];
  public filterdDistributor=[];
  public selectedItems = [];
  public selectedDist = [];
  filteredDetails:any = {distributor:[]};
  productImage;
  productCategories: any = [];
  productVarients: any = [];
  productVarientValues: any = [];
  subCategories: any = [];
  formData: any = {};
  distributor: any = [];
  check: boolean = true;
  distributorMultiselect: any = [];
  UserDetails:any;
  outletmasterSelected:boolean=false;
  
  constructor(
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private route: Router,
    private toast: ToastClientService
  ) { 
  }
  
  ngOnInit() {
    this.getUsersByRole(18);

    this.formData.is_loyalty = 1;
    this.getAllCategories();
    this.getproductVarient();



    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'text',
      selectAllText: 'Select All',
      itemsShowLimit: 3,
      allowSearchFilter: true,
      enableCheckAll: false

    };

  }

  toggleCheck() {
    this.check = !this.check;
    console.log(this.check)
  }


  onDistSelect(event) {
    this.selectedDist = [];
    this.selectedItems.forEach((entry) => {
      this.selectedDist.push(entry.id);
    })
  }
  imageChange(img) {
    console.log(img)
    var file = img.target.files[0];
    var reader = new FileReader();
    var self = this;
    reader.onloadend = function () {
      self.productImage = reader.result;
    }
    reader.readAsDataURL(file);

  }


  getAllCategories() {
    this.apiService.get(this.apiConfig.getAllCategiry)
      .subscribe((res: any) => {
        this.productCategories = res.data.ecommerce_categories
        // console.log(this.productCategories);
      }, err => {
        console.log(err);
      })
  }

  getSubcategories(id){
    console.log(id);
    this.apiService.get(this.apiConfig.getEcommerceSubCategories + id)
      .subscribe((res: any) => {
        this.subCategories = res.data.ecommerce_sub_categories;
      }, err => {
        console.log(err);
      })
  }

  getproductVarient() {
    this.apiService.get(this.apiConfig.getProductVarient)
      .subscribe((res: any) => {
        this.productVarients = res.data
        console.log(this.productVarients);
      }, err => {
        console.log(err);
      })
  }

  getVarientValues(id){
    this.apiService.get(this.apiConfig.getProductVarientValues + id)
      .subscribe((res: any) => {
        this.productVarientValues = res.data
        console.log(this.productVarientValues);
      }, err => {
        console.log(err);
      })
  }

  formateFillters(data, name){
    if(data.status == "singleSelect"){
      this.filteredDetails[name].push(data.data.id);
      return this.filteredDetails[name];
    }else if(data.status == "singleDeselect"){
      this.filteredDetails[name].forEach((element,i) => {
        if(element == data.data.id){
          this.filteredDetails[name].splice(i,1)
        }
      });
      return this.filteredDetails[name];
    }else if(data.status == "SelectAll"){
      this.filteredDetails[name] = [];
      if(data.data){
        data.data.forEach(element => {
          this.filteredDetails[name].push(element.id);
        });
      }
      return this.filteredDetails[name];
    }else if(data.status == "unSelectAll"){
      this.filteredDetails[name] = [];
      return this.filteredDetails[name];
    }
  }

  productSave() {
    this.formData.distributor_id = this.filteredDetails.distributor.toString();
    this.formData.program_id = 1;
    this.formData.product_thumb_image = this.productImage;
    this.formData.product_image1 = this.productImage;
    this.formData.brand_category_id = this.formData.category_id
    if (this.check == true) {
      this.formData.is_enabled = 1
    } else {
      this.formData.is_enabled = 0
    }
    this.apiService.postWithFormData(this.apiConfig.addToProductList, this.formData)
      .subscribe((res) => {
        if (res.status == 200) {
          this.toast.Success("Created Successfully");
          this.back();
        } else {
          console.log(res.data.message)
        }
      })
  }

  back() {
    this.route.navigateByUrl('/hubAdmin/products')
  }

  
  getUsersByRole(roleId) {
    let postdata= {
      "filter_search_geography": [],
      "filter_search_channel": [],
      "filter_search_region": [],
      "filter_search_userrole":[roleId]
    };
    this.apiService.post(this.apiConfig.getUsersFilter,postdata)
      .subscribe((res: any) => {
        this.dropdownList = res.body.data;
   
      console.log('Contest data is here')    

        console.log(this.dropdownList)    
      }, err => {
        console.log(err);
      })
  }

}